import * as React from 'react';
import enhance from './enhancer';
import { UserFollowerList, TitleBar } from '@/components/Common';
import { Loader } from 'semantic-ui-react';
import Pagination from '@/migration/pagination';

function Follower(props) {
  const {
    isLoading,
    users: {
      follower: { pages, current, totalCount },
      myFollowId,
    },
    onChangePage,
    isPaginationDisabled,
  } = props;

  return (
    <React.Fragment>
      <TitleBar title="フォロワー 一覧" />
      {pages.active.length === 0 || isLoading ? (
        <div className="my-follow-loader">
          <Loader active={isLoading} inline="centered" />
          {!isLoading ? <span>フォロワーはいません</span> : null}
        </div>
      ) : (
        <div className="my-follower">
          <UserFollowerList data={pages.active} followUsers={myFollowId} />
          <Pagination
            totalCount={totalCount}
            current={current}
            pageSize={5}
            changePage={onChangePage}
            disabled={isPaginationDisabled}
          />
        </div>
      )}
    </React.Fragment>
  );
}

export default enhance((props) => <Follower {...props} />);
